import React from 'react';
import { ChannelTypeInternal } from '../../../../../data-access/gql-types/graphql';
import { ChannelType } from '../../../types';
import ChannelDetailsBinarySensor from '../binary-sensor';
import Cover from '../cover';
import Gate from '../gate';
import Light from '../light';
import Meter from '../meter';
import Optimizer from '../optimizer';
import Sensor from '../sensor';
import Switch from '../switch';

type ChannelControlsProps = {
  channel: ChannelType;
};

const ChannelControls: React.FC<ChannelControlsProps> = ({ channel }) => {
  if (!channel) return null;

  switch (channel.data.type) {
    case ChannelTypeInternal.Blind:
      return <Cover channel={channel} />;
    case ChannelTypeInternal.Switch:
      return <Switch channel={channel} />;
    case ChannelTypeInternal.Meter:
      return <Meter channel={channel} />;
    case ChannelTypeInternal.Optimizer:
      return <Optimizer channel={channel} />;
    case ChannelTypeInternal.Light:
      return <Light channel={channel} />;
    case ChannelTypeInternal.Gate:
      return <Gate channel={channel} />;
    case ChannelTypeInternal.Sensor:
      return <Sensor channel={channel} />;
    case ChannelTypeInternal.BinarySensor:
      return <ChannelDetailsBinarySensor channel={channel} />;
    default:
      return null;
  }
};

export default ChannelControls;
